import React from 'react';
import { IconButton } from '@mui/material';
import spotifyIcon from '../../assets/spotify.png';
import { useUserStore } from '../../stores/userStore';
import { trackExternalLinkClick } from '../../lib/gaEvents';
import { EXTERNAL_LINK_TYPE, CONTENT_TYPE } from '../../constants/gaEnums';

const SpotifyButton = ({ url, contentId, pageType }) => {
  const user = useUserStore((state) => state.user);

  if (!url) return null;

  const handleClick = () => {
    trackExternalLinkClick(
      {
        linkType: EXTERNAL_LINK_TYPE.SPOTIFY,
        contentType: CONTENT_TYPE.ALBUM,
        contentId,
        pageType,
      },
      user,
    );
    window.open(url, '_blank');
  };

  return (
    <IconButton
      onClick={handleClick}
      disableRipple
      sx={{
        width: { xs: 32, md: 40 },
        height: { xs: 32, md: 40 },
        backgroundColor: 'transparent',
        padding: 0,
        '&:hover': {
          backgroundColor: 'transparent',
        },
        "html[data-theme='dark'] & img": {
          filter: 'brightness(1.16) saturate(1.18) drop-shadow(0 0 2px rgba(244, 240, 236, 0.28))',
        },
      }}
    >
      <img src={spotifyIcon} alt="Spotify" style={{ width: '100%', height: '100%' }} />
    </IconButton>
  );
};

export default SpotifyButton;
